import { ColorTokenKey } from '../../indigofair/data/ColorTokenKey';
import { IResponsiveSpacing } from '../../indigofair/data/IResponsiveSpacing';
import { Spacing } from '../../indigofair/data/Spacing';

export namespace ISpacerComponent {
  export namespace ISpacerComponentStyle {
    /**
     * Return an instance of ISpacerComponentStyle with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<ISpacerComponentStyle>
    ): ISpacerComponentStyle =>
      ({
        ...(partial ?? {}),
      }) as ISpacerComponentStyle;
  }

  export interface ISpacerComponentStyle {
    variant: keyof typeof ISpacerComponent.SpacerVariant | undefined;
    /**
     * Color of the content of the spacer component (The color of the lines)
     */
    color: keyof typeof ColorTokenKey | undefined;
  }

  export enum SpacerVariant {
    SPACER_VARIANT_UNKNOWN = 'SPACER_VARIANT_UNKNOWN',
    /**
     * No content spacer
     */
    DEFAULT = 'DEFAULT',
    /**
     * Horizontal line spacer
     */
    HORIZONTAL_LINE = 'HORIZONTAL_LINE',
  }

  /**
   * Return an instance of ISpacerComponent with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ISpacerComponent>
  ): ISpacerComponent =>
    ({
      ...(partial ?? {}),
    }) as ISpacerComponent;
}

export interface ISpacerComponent {
  vertical_spacing: keyof typeof Spacing | undefined;
  responsive_vertical_spacing: IResponsiveSpacing | undefined;
  style: ISpacerComponent.ISpacerComponentStyle | undefined;
}
